import axiosInstance from '../utils/axios';
import { TransactionOwnershipType } from "../@types/transactions";

const EXTEND_URL = '/purchases/v1/';
const REPORT_PURCHASE_URL = '/reports/purchases/v1/';
const PURCHASE_BY_QUOTE_URL = EXTEND_URL + 'quote';

//
//

export type GetPurchasesQueryParams = {
  ownershipType: TransactionOwnershipType | TransactionOwnershipType[],
  merchantCode: string | undefined,
  page: number,
  size: number,
  dateFrom?: string, // FIXME: Store in our own date object or luxon, but not string!
  dateTo?: string, // FIXME: Store in our own date object or luxon, but not string!
  email?: string,
  programmeCode?: string,
  fields?: string[],
  footprintTypeExclude?: string,
  withoutProgramme?: boolean;
}

function getPurchasesByMerchantCodeApi(params: GetPurchasesQueryParams) {
  // FIXME: before sending off the request, make sure to format the dates in this function 
  // (it belongs here because sepcific date format depends on the endpoint)
  return axiosInstance.get(
    `${REPORT_PURCHASE_URL}`,
    { params , paramsSerializer: { indexes: null } }
  );
}

function getPurchaseByIdApi(id: string) {
  return axiosInstance.get(`${EXTEND_URL}${id}`)
}

export interface ICreateCheckoutSessionMerchantSaas {
  customerEmail: string;
  priceId: string;
  successUrl: string;
  cancelUrl: string;
}

function createCheckoutSessionForSaasSubscription(merchantCode: string, data: ICreateCheckoutSessionMerchantSaas) {
  return axiosInstance.post(
      `/purchases/v1/subscription/merchant-saas/checkout-session/${merchantCode}`, JSON.stringify(data));
}

interface IStartPurchaseByQuoteData {
  quoteId: string;
}

async function startPurchaseByQuote(data: IStartPurchaseByQuoteData) {
  return axiosInstance.post(`${EXTEND_URL}quote/start`, data, {});
}

interface ICreatePurchaseByQuoteData {
  emailAddress: string;
  paymentIntentId?: string;
  paymentProvider: string;
  paymentProviderToken?: string | null;
  quoteId: string;
  disableNotifications: boolean;
  orderDescription?: string;
  paymentReference?: string;
}

async function createPurchaseByQuote(data: ICreatePurchaseByQuoteData) {
  try {
    const response = await axiosInstance.post(PURCHASE_BY_QUOTE_URL, data, {});
    return response?.data;
  } catch (error) {
    console.error("Failed to make a purchase by quote:", error);
    throw error;
  }
}


interface ICreateInvoiceRequest {
  quoteId: string;
  merchantCode: string;
}

async function createInvoiceRequest(data: ICreateInvoiceRequest) {
  return axiosInstance.post(`${EXTEND_URL}invoice/quote`, data, {})
}

async function linkBusinessCustomer({ purchaseId, businessCustomerId }: { purchaseId: string, businessCustomerId: string }) {
  return axiosInstance.patch(`${EXTEND_URL}${purchaseId}`, JSON.stringify({ businessCustomerId: businessCustomerId }));
}

export const getCertificateById = async (id: string) => {
  try {
    const response = await axiosInstance.get(`pdf-certificate/business/${id}`, {
      responseType: "blob",
      paramsSerializer: { indexes: null },
    });

    return response?.data;
  } catch (error) {
    console.error("Failed to fetch certificate:", error);
    throw error;
  }
}

export {
  getPurchasesByMerchantCodeApi,
  getPurchaseByIdApi,
  createCheckoutSessionForSaasSubscription,
  createPurchaseByQuote,
  startPurchaseByQuote,
  createInvoiceRequest,
  linkBusinessCustomer
};
